export const generateTitleBasedOnQuantity = nrOfItemsAddedToCart =>
  nrOfItemsAddedToCart > 1 ? 'items' : 'item'
